export const corrections = {
  english: {
    correctionLabel: 'Corrections',
    paragraph1:
      'The Guru Granth Sahib Project recognizes its responsibility to correct errors promptly. The team also acknowledges that theirs is a work in progress.',
    paragraph2:
    'Please contact us via email to request a correction if you have identified any error, minor or significant.',

    correctionEmail: 'corrections@sikhri.org',
  },
  panjabi: {
    correctionLabel: 'Corrections',
    paragraph1:
      'The Guru Granth Sahib Project recognizes its responsibility to correct errors promptly. The team also acknowledges that theirs is a work in progress.',
    paragraph2:
    'Please contact us via email to request a correction if you have identified any error, minor or significant.',

    correctionEmail: 'corrections@sikhri.org',
  },
};
